import React from 'react';

import { IChangeEvent } from '@rjsf/core';
import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { useSnackbar } from 'notistack';

import { Box, Button } from '@mui/material';

import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';
import VendorsService from '~/services/VendorsService';

const formSchema: RJSFSchema = {
  description: 'Please enter your dates to export WEX VCC payments for car hire reconciliation',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    fileFormat: {
      type: 'string',
      title: 'File Format',
      enum: ['csv', 'xlsx'],
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth(subMonths(1))),
  endAt: formatDateISO(startOfMonth()),
  fileFormat: 'xlsx',
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  fileFormat: {
    'ui:widget': 'radio',
  },
};

export default function ExportWexVccPaymentsForm() {
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = (event: IChangeEvent) => {
    const { startAt, endAt, fileFormat } = event.formData;

    VendorsService.downloadWexVccPaymentsReport({ startAt, endAt, fileFormat }).catch((err) => {
      enqueueSnackbar(err.message, { variant: 'error' });
    });
  };

  return (
    <Box>
      <Form
        schema={formSchema}
        uiSchema={uiSchema}
        formData={formData}
        onSubmit={handleSubmit}
        validator={validator}
        showErrorList={false}
      >
        <Button type="submit" variant="contained">
          Download WEX VCC Payments Report
        </Button>
      </Form>
    </Box>
  );
}
